import { useState, useEffect } from "react";
import { AuthServices } from "../../features/auth/services/AuthServices";

const useFetchOnboardingStatus = () => {
  const [stepNumber, setStepNumber] = useState(null);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const response = await AuthServices.fetchAccountStatus();

        if (!response.success) {
          console.log("Error fetching account status:", response);
          return;
        }
        const status = response.data;
        const step = updateStep(status);
        setStepNumber(step);
      } catch (err) {
        console.error("Failed to fetch account status:", err);
      }
    };

    fetchStatus();
  }, []);

  return stepNumber;
};

const updateStep = (status) => {
  const trueTotal = Object.values(status).filter((x) => x === true);
  return trueTotal.length;
};

export default useFetchOnboardingStatus;
